<template>
  <b-card class="mb-2 analytics-table-card">
    <template #header>
      <div class="section-header">
        <div class="d-flex align-items-center">
          <feather-icon
            icon="UsersIcon"
            size="16"
            class="mr-75 text-primary"
          />
          <h6 class="card-title mb-0">
            Sales by Retailer
          </h6>
        </div>
        <span class="badge-count">{{ salesByRetailer.length }} retailers</span>
        <download-menu
          filename="sales_by_retailer"
          :rows="salesByRetailer"
          :columns="downloadColumns"
        />
      </div>
    </template>

    <b-table
      :items="salesByRetailer"
      :fields="fields"
      sticky-header="360px"
      small
      hover
      show-empty
      empty-text="No retailer data for the selected period"
      class="analytics-table mb-0"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
    >
      <template #cell(retailerName)="{ item }">
        <div class="d-flex align-items-center">
          <div class="retailer-avatar mr-75">
            {{ getInitials(item.retailerName) }}
          </div>
          <span class="font-weight-semibold">{{ item.retailerName }}</span>
        </div>
      </template>

      <template #cell(orders)="{ item }">
        <span class="font-weight-semibold">{{ Number(item.orders || 0).toLocaleString() }}</span>
      </template>

      <template #cell(totalSales)="{ item }">
        <span class="font-weight-semibold text-nowrap">
          {{ formatCurrency(item.totalSales || 0) }}
        </span>
      </template>

      <template #cell(share)="{ item }">
        <div class="share-cell">
          <div class="share-bar-wrap">
            <div
              class="share-bar"
              :style="{ width: `${Math.min(Math.max(Number(item.share) || 0, 0), 100)}%` }"
            />
          </div>
          <span class="share-label">{{ (Math.max(Number(item.share) || 0, 0)).toFixed(1) }}%</span>
        </div>
      </template>
    </b-table>
  </b-card>
</template>

<script>
import { BCard, BTable } from 'bootstrap-vue'
import DownloadMenu from './DownloadMenu.vue'
import { formatCurrency } from '../analyticsFormat'

export default {
  name: 'AnalyticsSalesByRetailer',
  components: { BCard, BTable, DownloadMenu },
  props: {
    salesByRetailer: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      sortBy: 'totalSales',
      sortDesc: true,
      fields: [
        {
 key: 'retailerName', label: 'Retailer', sortable: true, thClass: 'table-col-header',
},
        {
 key: 'orders', label: 'Orders', sortable: true, thClass: 'table-col-header text-right', tdClass: 'text-right',
},
        {
 key: 'totalSales', label: 'Total Sales', sortable: true, thClass: 'table-col-header text-right', tdClass: 'text-right',
},
        {
 key: 'share', label: 'Share', sortable: true, thClass: 'table-col-header', thStyle: { width: '160px' },
},
      ],
    }
  },
  computed: {
    downloadColumns() {
      const fmt = n => new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(n) || 0)
      return [
        { key: 'retailerName', label: 'Retailer' },
        { key: 'orders', label: 'Orders' },
        { key: 'unitsSold', label: 'Units Sold' },
        { key: 'totalSales', label: 'Total Sales', format: v => fmt(v) },
        { key: 'share', label: 'Share %', format: v => `${(Number(v) || 0).toFixed(1)}%` },
      ]
    },
  },
  methods: {
    formatCurrency,
    getInitials(name) {
      if (!name) return '?'
      return name.trim().split(/\s+/).slice(0, 2).map(w => w[0].toUpperCase())
.join('')
    },
  },
}
</script>

<style lang="scss" scoped>
@import './analytics-table';

.retailer-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #dbeafe;
  color: #1e40af;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.65rem;
  font-weight: 700;
  flex-shrink: 0;
}

.share-cell {
  display: flex;
  align-items: center;
  gap: 8px;

  .share-bar-wrap {
    flex: 1;
    height: 6px;
    background: #e9eef6;
    border-radius: 3px;
    overflow: hidden;
  }

  .share-bar {
    height: 100%;
    background: linear-gradient(90deg, #1e40af, #3b82f6);
    border-radius: 3px;
    transition: width 0.4s ease;
  }

  .share-label {
    font-size: 0.75rem;
    font-weight: 600;
    color: #374151;
    min-width: 38px;
    text-align: right;
  }
}
</style>
